import { Injectable, NgModule, ModuleWithProviders, SkipSelf } from '@angular/core';
import { HttpModule, Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

export class AzureAdConfig {
    public tenant: string;
    public clientId: string;
    public redirectUri: string;
    public postLogoutRedirectUri: string;
    public redirectPath: string;
    public instance: string;
    public isTenantEnabled: boolean;
    public forgeRockEnabled: boolean;
    
}


@Injectable()
export class AppSettingsService {
    private redirectPath: string;
    public forgeRockEnabled: boolean;
    public ApiUrl: string = window.location.protocol + '//' + window.location.host + "/api/appsettings";
    private headers: Headers;
    public adalConfigSettings: AzureAdConfig;
   
    constructor(private http: Http) {

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
    }

    public get adalConfig(): AzureAdConfig {

        return this.adalConfigSettings;
    }

    getGlobalName() {
        let url = `${this.ApiUrl}/globalname`;
        return this.http.get(url)
            .catch((error: any) => {
            return Observable.throw(error);
        });
    }

    getSystemServices() {
        let url = `${this.ApiUrl}/systemservices`;
        return this.http.get(url)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getAppSettings(): Promise<AzureAdConfig> {

        var observable = this.http.get(`${this.ApiUrl}/get`, { headers: this.headers })
            .map((response: Response) => {

                var res = response.json();
                this.forgeRockEnabled = res[6] === "true";
                return this.extractRequiredSettings(res);
            });

        observable.subscribe(user => {
            this.adalConfigSettings = user;
        });
        var pr = observable.toPromise();
        return pr;
    }

    load(): Promise<AzureAdConfig> {
        return new Promise((resolve) => {
            this.http.get(`${this.ApiUrl}/get`, { headers: this.headers }).map(res => res.json())
                .subscribe(config => {
                    this.setAdalConfigSettings(config);
                    localStorage.setItem("sent-cfg", JSON.stringify(this.adalConfigSettings));
                    resolve();
                });
        });
    }

    public loadC(): Promise<void> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let url = `${this.ApiUrl}/get`;

        return this.http.get(url, { headers }).toPromise().
            then(config => {
                this.setAdalConfigSettings(config);
            }).catch(err => {
                log(err);
            });
    }

    private setAdalConfigSettings(config: Response) {
        this.adalConfigSettings = this.extractRequiredSettings(config);
    }

    private extractRequiredSettings(config: Response): AzureAdConfig {
        return {
            tenant: config[1],
            clientId: config[2],
            postLogoutRedirectUri: config[3],
            redirectPath: window.location.pathname,
            redirectUri: config[3],
            instance: config[4],
            isTenantEnabled: config[5] === "true",
            forgeRockEnabled: config[6] === "true"
            
        };
    }

    public setRedirectPath(value: string) {
        this.adalConfigSettings.redirectPath = window.location.pathname;
    }

    public setRedirectUri(value: string) {
        this.adalConfigSettings.redirectUri = window.location.origin + window.location.pathname;
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/services/appsettings.service.ts
 **/